module.exports = __webpack_public_path__ + "static/img/14010209.ad185b99.png";